export default __webpack_public_path__ + "static/media/banner-bottom.99c67009.svg";